import { render } from "./checkbox-with-radio.vue?vue&type=template&id=1ce7b6b2"
import script from "./checkbox-with-radio.vue?vue&type=script&lang=ts"
export * from "./checkbox-with-radio.vue?vue&type=script&lang=ts"
script.render = render

export default script